import { useTranslation } from "react-i18next";
import { Policy } from "../../../models/Policies";
import { ConfirmationModal } from "../../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        policy?: Policy;
    };
    onClose: () => void;
    deletePolicy: (policy: Policy) => void
}

export const DeleteClientPolicyModal: React.FC<Props> = ({
    info,
    onClose,
    deletePolicy
}) => {

    const { t } = useTranslation();

    const onDeletePolicy = () => {
        deletePolicy(info.policy!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_POLICY")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeletePolicy }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_POLICY_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}